import { images } from "../../Constants/imageslinks";

function AddictiveAppCards() {
  return (
    <div className="bg-primary200">
      <div className="3xl:container 3xl:mx-auto lg:px-[3.88vw] 3xl:px-[75px] md:px-8 px-4 lg:py-[72px] py-7 flex lg:flex-row flex-col-reverse lg:gap-[73px] gap-6 items-center leading-[100%]">
        <div>
          <div className="grid md:grid-cols-4 grid-cols-2 gap-[19px]">
            <img src={images.addictiveCardImage1} alt="image1" />
            <img src={images.addictiveCardImage2} alt="image2" />
            <img src={images.addictiveCardImage3} alt="image3" />
            <img src={images.addictiveCardImage4} alt="image4" />
          </div>
        </div>

        <div className="flex flex-col lg:gap-6 gap-4 md:min-w-[456px]">
          <p className="font-light sm:text-3xl text-xl md:leading-[100%] leading-[30px] sm:text-black text-secondary100">
            Get control over addictive apps
          </p>
          <p className="font-light text-base leading-6 md:text-black text-secondary100">
            The default iPhone UI makes it too easy to start doom-scrolling.
            Minimis Phone builds in mindfulness checks, so you can be fully
            mindful of your iPhone usage.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AddictiveAppCards;
